export const EXPLORE_STEPS = [
  { id: 'start', label: 'Intro', path: '/explore/start' },
  { id: 'discover', label: 'Discovery', path: '/explore/discover' },
  { id: 'neo', label: 'Neo', path: '/explore/neo' },
  { id: 'morpheus', label: 'Morpheus', path: '/explore/morpheus' },
  { id: 'link', label: 'Link', path: '/explore/link' },
  { id: 'build', label: 'Build', path: '/explore/build' },
  { id: 'launch', label: 'Launch', path: '/explore/launch' },
];

export const getStepIndex = (stepId) => EXPLORE_STEPS.findIndex((step) => step.id === stepId);
export const getStep = (stepId) => EXPLORE_STEPS.find((step) => step.id === stepId) || EXPLORE_STEPS[0];
export const getNextStep = (stepId) => EXPLORE_STEPS[Math.min(getStepIndex(stepId) + 1, EXPLORE_STEPS.length - 1)];
export const getPrevStep = (stepId) => EXPLORE_STEPS[Math.max(getStepIndex(stepId) - 1, 0)];
